// extracted by mini-css-extract-plugin
module.exports = {"frame":"FormImage_frame__ftcvn","frameInner":"FormImage_frameInner__3qtCa","content":"FormImage_content__3XzAR","zone":"FormImage_zone__2RgMG"};